import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/vendors/HotelScreens/hotelSettings.css';
import AppContext from '../../../context/AppContext';
import VendorLayout from "../../../layout/HotelVendorLayout/VendorLayout";

const HotelRegistration = () => {
  const { baseUrl, validateField, authToken, setHotelId } = useContext(AppContext); 
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isExistingHotel, setIsExistingHotel] = useState(false);
  
  const vendorId = localStorage.getItem("vendorId");
  const vendorEmail = localStorage.getItem("vendorEmail");
  
  const [hotelData, setHotelData] = useState({
    jjvendor_id: vendorId || '',
    hotel_name: '',
    owner_name: '',  
    total_rooms: '',
    phone: '',
    address: '',
    check_in_time: '14:00',
    check_out_time: '12:00',
    description: '',
    facilities: [],
    stars: 3,
    hotel_status: 'inactive',
    hotel_image: ''
  });

  const [hotelImage, setHotelImage] = useState(null);
  const [hotelImagePreview, setHotelImagePreview] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const facilitiesOptions = [
    { id: 'wifi', label: 'Free WiFi' },
    { id: 'parking', label: 'Free Parking' },
    { id: 'breakfast', label: 'Free Breakfast' },
    { id: 'gym', label: 'Gym' },
    { id: 'tv', label: 'TV in Rooms' },
    { id: 'pool', label: 'Swimming Pool' },
    { id: 'restaurant', label: 'Restaurant' },
    { id: 'ac', label: 'AC Rooms' },
    { id: 'security', label: '24/7 Security' }
  ];

  useEffect(() => {
    console.log("========== HOTEL REGISTRATION DEBUG ==========");
    
    if (localStorage.getItem("vendorId")) {
      const storedId = localStorage.getItem("vendorId");
      setHotelData(prev => ({ ...prev, jjvendor_id: storedId }));
    }
    
    if (vendorId) {
      axios.get(`${baseUrl}/vendor/hotel/get`, {
        params: { jjvendor_id: vendorId },
        headers: {  
          'Authorization': `Bearer ${authToken}`
        }
      })
      .then(response => {
        if (response.data.success) {
          const hotel = response.data.data;

          setHotelId(hotel.id);
          localStorage.setItem("hotelId", hotel.id);
          console.log("#################");
          console.log(authToken); 
          console.log("#################");
          console.log(response.data);
          console.log("Full Hotel Data:", hotel);      
          
          let facilities = hotel.facilities;
          if (typeof facilities === 'string') {
            try {
              facilities = JSON.parse(facilities);
            } catch (e) {
              facilities = [];
            }
          }
          
          setIsExistingHotel(true);
          
          setHotelData({
            jjvendor_id: hotel.jjvendor_id,
            hotel_name: hotel.hotel_name || '',
            owner_name: hotel.owner_name || '',
            total_rooms: hotel.total_rooms || '',
            phone: hotel.phone || '',
            address: hotel.address || '',
            check_in_time: hotel.check_in_time || '14:00',
            check_out_time: hotel.check_out_time || '12:00',
            description: hotel.description || '',
            facilities: facilities || [],
            stars: hotel.stars || 3,
            hotel_status: hotel.hotel_status || 'inactive',
            hotel_image: hotel.hotel_image || '' 
          });
        }
      })
      .catch(error => {
        if (error.response?.status === 404) {
          console.log('No hotel found for this vendor');
          setIsExistingHotel(false);
        } else {
          console.log('Error fetching hotel:', error.message);
        }
      });
    }
    
  }, [vendorId, baseUrl, authToken]); 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHotelData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleFacilityChange = (facilityId) => {
    setHotelData(prev => {
      const currentFacilities = [...prev.facilities];
      const newFacilities = currentFacilities.includes(facilityId)
        ? currentFacilities.filter(id => id !== facilityId)
        : [...currentFacilities, facilityId];
      
      return {
        ...prev,
        facilities: newFacilities
      };
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setMessage('Image size should be less than 5MB');
        setMessageType('error');
        setTimeout(() => setMessage(''), 3000);
        return;
      }

      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/avif'];
      if (!validTypes.includes(file.type)) {
        setMessage('Please upload a valid image (JPEG, PNG, GIF, WebP, AVIF)');
        setMessageType('error');
        setTimeout(() => setMessage(''), 3000);
        return;
      }

      setHotelImage(file);
      
      const reader = new FileReader();
      reader.onload = () => {
        setHotelImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleStarsChange = (stars) => {
    setHotelData(prev => ({
      ...prev,
      stars
    }));
  };

  const validateForm = () => {
    const errors = {};
    
    const ownerNameErr = validateField('name', hotelData.owner_name);
    if (ownerNameErr) errors.owner_name = ownerNameErr;
    
    const phoneErr = validateField('phone', hotelData.phone);
    if (phoneErr) errors.phone = phoneErr;
    
    if (!hotelData.hotel_name.trim()) errors.hotel_name = 'Hotel name is required';
    if (!hotelData.total_rooms || hotelData.total_rooms <= 0) errors.total_rooms = 'Please enter valid number of rooms';
    if (!hotelData.address.trim()) errors.address = 'Address is required';
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const finalVendorId = localStorage.getItem("vendorId");
    
    console.log("Final vendorId being sent:", finalVendorId);
    
    if (!finalVendorId) {
      setMessage('Please login first');
      setMessageType('error');
      setTimeout(() => navigate('/auth/login'), 2000);
      return;
    }
    
    if (!validateForm()) {
      setMessage('Please fill in all required fields correctly');
      setMessageType('error');
      setTimeout(() => setMessage(''), 3000);
      return;
    }
    
    setIsLoading(true);
    
    if (isExistingHotel) {
      setMessage('Updating hotel...');
    } else {
      setMessage('Registering hotel...');
    }
    setMessageType('success');
    
    const formData = new FormData();
    formData.append('jjvendor_id', finalVendorId);
    formData.append('hotel_name', hotelData.hotel_name);
    formData.append('owner_name', hotelData.owner_name);
    formData.append('total_rooms', hotelData.total_rooms);
    formData.append('phone', hotelData.phone);
    formData.append('address', hotelData.address);
    formData.append('check_in_time', hotelData.check_in_time);
    formData.append('check_out_time', hotelData.check_out_time);
    formData.append('description', hotelData.description || '');
    formData.append('stars', hotelData.stars);
    formData.append('facilities', JSON.stringify(hotelData.facilities));
    formData.append('hotel_status', hotelData.hotel_status);
    
    if (hotelImage) {
      formData.append('hotel_image', hotelImage);
    }

    const apiUrl = isExistingHotel 
      ? `${baseUrl}/vendor/hotel/update`
      : `${baseUrl}/vendor/hotel/register`;

    axios.post(apiUrl, formData, {
      headers: { 
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`  
      }
    })
    .then(response => {
      console.log("Response:", response.data);
      setIsLoading(false);
      if (response.data.success === true) {
        if (response.data.data?.id) {
        setHotelId(response.data.data.id);
        localStorage.setItem("hotelId", response.data.data.id);
      }
        if (isExistingHotel) {
          setMessage('Hotel updated successfully!');
          setMessageType('success');
          setTimeout(() => setMessage(''), 2000); 
        } else {
          setMessage('Hotel registered successfully! Redirecting...');
          setMessageType('success');
          setTimeout(() => {
            navigate('/vendor/hotel-dashboard');
          }, 1500);
        }
      } else {
        setMessage(response.data.message || (isExistingHotel ? 'Update failed' : 'Registration failed'));
        setMessageType('error');
        setTimeout(() => setMessage(''), 3000);
      }
    })
    .catch(error => {
      console.log("Error Response:", error.response?.data);
      setMessage(error.response?.data?.message || (isExistingHotel ? 'Update failed' : 'Registration failed'));
      setMessageType('error');
      setIsLoading(false);
      setTimeout(() => setMessage(''), 3000);
    });
  };

  return (
    <VendorLayout>
      <Container fluid className="hotel-setting-page py-4">
        <div className="w-100" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Card className="hotel-setting-card shadow">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <Card.Title className="fw-bold display-6 hotel-setting-title">
                  <i className="fas fa-hotel me-3" style={{ color: '#4A9E8E' }}></i>
                  {isExistingHotel ? 'Update Hotel' : 'Hotel Registration'}
                </Card.Title>
                <p className="text-muted mb-0">
                  {isExistingHotel 
                    ? 'Update your hotel information' 
                    : 'Register your hotel to start managing bookings'}
                </p>
                {vendorEmail && (
                  <p className="text-success mt-2">
                    <i className="fas fa-check-circle me-1"></i>
                    Logged in as: <strong>{vendorEmail}</strong>
                  </p>
                )}
              </div>
              
              {message && (
                <p className={`ta-message ta-${messageType} text-center mb-4`}>
                  {message}
                </p>
              )}
              
              <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <h5 className="fw-bold mb-3 border-bottom pb-2">
                    <i className="fas fa-info-circle me-2"></i>
                    Basic Information
                  </h5>
                  
                  <Row>
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Hotel Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="hotel_name"
                          value={hotelData.hotel_name}
                          onChange={handleInputChange}
                          placeholder="Enter hotel name"
                          isInvalid={!!formErrors.hotel_name}
                          disabled={isLoading}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.hotel_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Owner Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="owner_name"
                          value={hotelData.owner_name}
                          onChange={handleInputChange}
                          placeholder="Enter owner name"
                          isInvalid={!!formErrors.owner_name}
                          disabled={isLoading}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.owner_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Total Rooms <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="total_rooms"
                          value={hotelData.total_rooms}
                          onChange={handleInputChange}
                          placeholder="Enter number of rooms"
                          min="1"
                          isInvalid={!!formErrors.total_rooms}
                          disabled={isLoading}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.total_rooms}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Phone Number <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          value={hotelData.phone}
                          onChange={handleInputChange}
                          placeholder="03001234567"
                          isInvalid={!!formErrors.phone}
                          disabled={isLoading}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.phone}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col lg={12} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Address <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="address"
                          value={hotelData.address}
                          onChange={handleInputChange}
                          placeholder="Enter hotel address"
                          isInvalid={!!formErrors.address}
                          disabled={isLoading}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.address}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Check-In Time
                        </Form.Label>
                        <Form.Control
                          type="time"
                          name="check_in_time"
                          value={hotelData.check_in_time}
                          onChange={handleInputChange}
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>
                    
                    <Col lg={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Check-Out Time
                        </Form.Label>
                        <Form.Control
                          type="time"
                          name="check_out_time"
                          value={hotelData.check_out_time}
                          onChange={handleInputChange}
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold mb-3 border-bottom pb-2">
                    <i className="fas fa-star me-2"></i>
                    Hotel Rating
                  </h5>
                  
                  <div className="mb-3">
                    <Form.Label className="fw-semibold">
                      Select Hotel Stars
                    </Form.Label>
                    <div className="d-flex align-items-center gap-2 mt-2">
                      {[1, 2, 3, 4, 5].map(star => (
                        <Button
                          key={star}
                          type="button"
                          variant={hotelData.stars >= star ? "warning" : "outline-warning"}
                          onClick={() => !isLoading && handleStarsChange(star)}
                          disabled={isLoading}
                          style={{ fontSize: '1.5rem', padding: '0.5rem 1rem' }}
                        >
                          ★
                        </Button>
                      ))}
                      <span className="ms-3 fw-semibold">
                        {hotelData.stars} Star{hotelData.stars > 1 ? 's' : ''} Hotel
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold mb-3 border-bottom pb-2">
                    <i className="fas fa-concierge-bell me-2"></i>
                    Hotel Facilities
                  </h5>
                  
                  <Row>
                    {facilitiesOptions.map(facility => (
                      <Col md={4} key={facility.id} className="mb-2">
                        <Form.Check
                          type="checkbox"
                          id={facility.id}
                          label={facility.label}
                          checked={hotelData.facilities.includes(facility.id)}
                          onChange={() => !isLoading && handleFacilityChange(facility.id)}
                          disabled={isLoading}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold mb-3 border-bottom pb-2">
                    <i className="fas fa-image me-2"></i>
                    Hotel Image
                  </h5>
                  
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Upload Hotel Image
                        </Form.Label>
                        
                        <Form.Control
                          type="file"
                          id="hotelImage"
                          accept="image/*"
                          onChange={handleImageChange}
                          disabled={isLoading}
                          className="mb-2"
                        />
                        
                        <Form.Text className="text-muted">
                          <i className="fas fa-info-circle me-1"></i>
                          Max 5MB (JPG, PNG, GIF)
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    
                    <Col md={6}>
                      <div className="text-center">
                        {hotelImagePreview ? (
                          <img 
                            src={hotelImagePreview} 
                            alt="Preview" 
                            className="img-fluid rounded border"
                            style={{ maxHeight: '150px', objectFit: 'cover' }}
                          />
                        ) : hotelData.hotel_image ? (
                          <img 
                            src={`http://127.0.0.1:8000/storage/${hotelData.hotel_image.replace(/ /g, '%20')}`} 
                            alt="Hotel" 
                            className="img-fluid rounded border"
                            style={{ maxHeight: '150px', objectFit: 'cover' }}
                          />
                        ) : (
                          <div className="image-message-box">
                            <p className="image-message-text">No image uploaded</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold mb-3 border-bottom pb-2">
                    <i className="fas fa-file-alt me-2"></i>
                    Additional Information
                  </h5>
                  
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="description"
                          value={hotelData.description}
                          onChange={handleInputChange}
                          placeholder="Describe your hotel..."
                          disabled={isLoading}
                        />
                      </Form.Group>
                    </Col>
                    
                  </Row>
                </div>

                <div className="d-flex justify-content-center">
                   <Button 
                      variant="primary"  
                      type="submit"
                      size="lg"
                      disabled={isLoading}
                      className="px-5" >
                      {isLoading 
                       ? (isExistingHotel ? "Updating..." : "Registering...") 
                      : (isExistingHotel ? "Update Hotel" : "Register Hotel")}
                     </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </VendorLayout>
  );
};

export default HotelRegistration;